import { QueryKey, createQueryKey } from '../../../query';

const salesTaxSettingsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'salesTaxSettings'] as const,
  });

export { salesTaxSettingsKeys };
